import { useAuthStore } from '@/features/auth/useAuthStore.js'

function getFirstQueryValue(value) {
  return Array.isArray(value) ? value[0] : value
}

function getRedirectUrlWithoutLoginOnlyParams(to) {
  if (!to?.fullPath) return ''

  const redirectUrl = new URL(to.fullPath, window.location.origin || 'http://localhost')
  redirectUrl.searchParams.delete('activeClubId')
  redirectUrl.searchParams.delete('token')

  return `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`
}

export function authGuard(to, from, next) {
  const authStore = useAuthStore()

  const token = to?.query?.token

  if (token) {
    authStore.setUserToken(token)
    next(to.path)
  }

  if (!authStore.isLoggedIn) {
    const _redirectUrl = getRedirectUrlWithoutLoginOnlyParams(to)
    const activeClubId = getFirstQueryValue(to?.query?.activeClubId)
    const isLogin = window.location.pathname.includes('auth/login')

    function getRedirectUrl() {
      if (isLogin) {
        return ''
      }

      return _redirectUrl
    }

    const redirectUrl = getRedirectUrl()

    const params = new URLSearchParams()

    if (redirectUrl) {
      params.set('redirectUrl', redirectUrl)
    }

    if (activeClubId) {
      params.set('activeClubId', activeClubId)
    }

    next({
      path: '/auth/login',
      query: Object.fromEntries(params.entries()),
    })
    return
  }

  next()
}
